import { render } from "./HeartRateMonitor.vue?vue&type=template&id=094b41e3&scoped=true"
import script from "./HeartRateMonitor.vue?vue&type=script&lang=js"
export * from "./HeartRateMonitor.vue?vue&type=script&lang=js"

import "./HeartRateMonitor.vue?vue&type=style&index=0&id=094b41e3&scoped=true&lang=scss"
import "./HeartRateMonitor.vue?vue&type=style&index=1&id=094b41e3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094b41e3"]])

export default __exports__